module.exports = __webpack_public_path__ + "img/20.cd7edd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/20.png
// module id = tAyz
// module chunks = 1